<template>
  <component :is="clockComponent" v-model:date="date"
    @showHours="clockComponent = DatePickerTimeHours"
    @showMinutes="clockComponent = DatePickerTimeMinutes"
    @selectedHour="hour => onSelectHour(hour)"
    @selectedMinute="minute => onSelectMinute(minute)"
  ></component>
</template>

<script setup>
import { shallowRef, watch } from "vue";
import DatePickerTimeClock from "./DatePickerTimeClock.vue";
import DatePickerTimeHours from "./DatePickerTimeHours.vue";
import DatePickerTimeMinutes from "./DatePickerTimeMinutes.vue";

let props = defineProps([
  "date"
]);

let date = defineModel("date");
let clockComponent = shallowRef(DatePickerTimeClock);
watch(date, () => clockComponent.value = DatePickerTimeClock);

function onSelectHour(hour12) {
  let newDate = new Date(date.value);
  let isPm = props.date.getUTCHours() >= 12;
  let hour24 = (isPm && hour12 < 12) ? hour12 + 12 : hour12;
  newDate.setUTCHours(hour24);
  date.value = newDate;
}

function onSelectMinute(minute) {
  let newDate = new Date(date.value);
  newDate.setUTCMinutes(minute);
  date.value = newDate;
}
</script>